import styled from 'styled-components';

const BoardOfTrusteesTemplateStyle = styled.section`
	--trusteesTitleMargin: var(--sp8x);
	--trusteesGap: var(--sp4x);

	margin-top: var(--pageDistance);

	.trustees-title-wrapper {
		margin-bottom: var(--trusteesTitleMargin);
	}

	.trustees-container-wrapper .row {
		row-gap: var(--trusteesGap);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--trusteesTitleMargin: var(--sp7x);
		--trusteesGap: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--trusteesTitleMargin: var(--sp6x);
		--trusteesGap: var(--sp3x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--trusteesTitleMargin: var(--sp5x);
		--trusteesGap: var(--sp2-5x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--trusteesTitleMargin: var(--sp5x);
		--trusteesGap: var(--sp2-5x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--trusteesTitleMargin: var(--sp4x);
		--trusteesGap: var(--sp2-5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--trusteesTitleMargin: var(--sp4x);
		--trusteesGap: var(--sp2-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--trusteesTitleMargin: var(--sp3x);
		--trusteesGap: var(--sp2x);
	}
`;

export default BoardOfTrusteesTemplateStyle;
